module.exports = __webpack_public_path__ + "img/white_long_logo.d6f48d8a.png";